import wrapURL from '@/components/fedexPickup/FedexPickupData/interceptorWithoutNotification.js';

//this is wrapped by the interceptor without error notification popup
export const fedexPickupBaseURL = wrapURL(
    process.env.VUE_APP_ENV == "production"
    ? "https://api.vibrant-wellness.com/v1/lis/shipping" // production
    : "https://api.vibrant-wellness.com/v1/lis/shipping/staging" //staging
)

//this is wrapped by the interceptor without error notification popup
export const fedexPickupOrderBaseURL = wrapURL(
    process.env.VUE_APP_ENV=='production' 
    // 04/08/2025: Fangyuan asked to replace the cloud production order endpoint to be the local version due to different catche of blood concierge
    // 04/30/2026: VIB-1709 Replace the local production order endpoint to be the cloud version
    ? 'https://api.vibrant-wellness.com/v1/portal/order' // production
    // ? 'https://api.vibrant-wellness.com/v1/portal/order' // cloud production
    :'https://api.vibrant-wellness.com/v1/portal/order/staging' //staging
);

//this is wrapped by the interceptor without error notification popup
// VIB-1775: trans-service v1. GET /trans/patientDetail replaces billing's GET /orderTest/patient for the
// patient-on-file read, because billing's DTO drops the address unit (apt_po) while trans keeps it.
export const fedexPickupTransBaseURL = wrapURL(
    process.env.VUE_APP_ENV=='production'
    ? 'https://api.vibrant-wellness.com/v1/portal/trans-service' // production
    :'https://api.vibrant-wellness.com/v1/portal/trans-service-st' //staging
);

//this is wrapped by the interceptor without error notification popup
export const sampleBaseURL = wrapURL(
    process.env.VUE_APP_ENV == "production" 
    ? "https://api.vibrant-wellness.com/v1/lis/samples" 
    : "https://api.vibrant-wellness.com/v1/lis/samples/staging"
);

//this is wrapped by the interceptor without error notification popup
export const fedexPickupPricingBaseURL = wrapURL(
    process.env.VUE_APP_ENV=='production' 
    // 04/08/2025 VIB-892: Rui deprecated the previous order API, rewrite it to be new ones
    ? 'https://api.vibrant-wellness.com/v1/pricing' // cloud production
    :'https://api.vibrant-wellness.com/v1/pricing/staging' //staging cloud endpoint
);